document.addEventListener('DOMContentLoaded', () => {
  const frontPageScrollerElem = document.querySelector('.mod-scroller');

  if (frontPageScrollerElem) {
    const scrollerSections = [...frontPageScrollerElem.querySelectorAll('.mod-scroller__section')];
    const introSectionIndex = scrollerSections.findIndex((section) =>
      section.querySelector('.intro-module__text'),
    );
    const scrollingSectionElement =
      introSectionIndex >= 0
        ? scrollerSections[introSectionIndex].querySelector('.intro-module__text')
        : null;

    // eslint-disable-next-line
    const fullpageAnim = new fullpage('#fullpage', {
      licenseKey: 'K6P3H-D9O98-370K9-GWJSJ-YMRCO',
      sectionSelector: '.mod-scroller__section',
      normalScrollElements: '.intro-module__text, .sc-splash-screen',
      fixedElements: '.menu',
      scrollingSpeed: 500,
      css3: true,
      easing: 'easeInOutCubic',
      touchSensitivity: 15,
      onLeave: (origin, destination) => {
        const section1 = origin.item.classList.contains('mod-scroller__section1');
        const section2 = destination.item.classList.contains('mod-scroller__section2');
        const section3 = origin.item.classList.contains('mod-scroller__section3');

        if (scrollingSectionElement) {
          if (section1 && section2) {
            scrollingSectionElement.scrollTop = 2;
          }
          if (section3 && section2) {
            scrollingSectionElement.scrollTop =
              scrollingSectionElement.scrollHeight - scrollingSectionElement.clientHeight - 10;
          }
        }

        // If not on first section then stop autoplay because of dissappearing text on iOS (performance issues also)
        if (destination.index === 0) {
          if (landingSlider) {
            landingSlider.autoplay.start();
          }
        } else {
          // eslint-disable-next-line
          if (landingSlider) {
            landingSlider.autoplay.stop();
          }
        }
      },
    });

    if (scrollingSectionElement && introSectionIndex >= 0) {
      const introSectionOneBased = introSectionIndex + 1;

      scrollingSectionElement.addEventListener('scroll', () => {
        if (
          Math.floor(scrollingSectionElement.scrollTop) + 2 + scrollingSectionElement.clientHeight >
          scrollingSectionElement.scrollHeight
        ) {
          // eslint-disable-next-line
          fullpage_api.moveTo(introSectionOneBased + 1);
        }
        if (scrollingSectionElement.scrollTop === 0) {
          // eslint-disable-next-line
          fullpage_api.moveTo(introSectionOneBased - 1);
        }
      });
    }
  }
});
